import DOMPurify from "dompurify";
import he from "he";
import { getCategoryDetails } from "./";
import logger from "../../../../lib/logger";
import { getWindow } from "../../../../helpers/getWindow";

const ALLOWED_TAGS = [
  "a",
  "img",
  "p",
  "span",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "b",
  "i",
  "u",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];

const ALLOWED_ATTR = [
  "href",
  "name",
  "target",
  "rel",
  "title",
  "src",
  "alt",
  "class",
];

let purify;

const getPurify = () => {
  const win = getWindow();

  if (purify) {
    return purify;
  }

  if (win) {
    purify = DOMPurify(win);
  }

  if (SERVER) {
    const { JSDOM } = require("jsdom");

    purify = DOMPurify(new JSDOM("").window);
  }

  return purify;
};

const sanitize = (html) =>
  getPurify().sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });

export default (state) => {
  const footerHtmlEncoded =
    getCategoryDetails(state)?.footerHtmlEncoded || null;

  if (!footerHtmlEncoded || footerHtmlEncoded.length <= 1) {
    return null;
  }

  try {
    const decoded = he.decode(footerHtmlEncoded);

    return sanitize(decoded);
  } catch (error) {
    logger.error(error);

    return null;
  }
};
